import React from "react";
import "../css/landing.css";
import main from "../assets/alqaim.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Landing() {
  const navigate = useNavigate();
  const currentTheme = useSelector((state) => state.theme.current);

  return (
    <div className="landing" style={{ background: `${currentTheme}` }}>
      <div
        className="availability"
        style={{
          color: "red",
          fontSize: "24px",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {/* <p>Currently, we are available in Mumbai only        ہم فی الحال صرف ممبئی میں دستیاب ہیں</p> */}
        {/* <p>ہم فی الحال صرف ممبئی میں دستیاب ہیں۔</p> */}
      </div>
      <span className="left">
        <div className="caption1">
          <hr />
          {/* <h4>WE ARE Al Qaim Welfare Foundation</h4> */}
        </div>
        <div className="titles">
          <div className="caption2">
            <p>
              At <span>Al Qaim Welfare Foundation,</span> we work under the
              guidance of <span> Aalim-e-deen </span>
            </p>
          </div>
          <div
            className="caption3"
            style={{ position: "relative", top: "-20px" }}
          >
            <p>
              <h3>Rasule Khuda (saww) :-</h3>
              Sadqa is hadd tak do ke kaha jaaye ke tumne israaf kiya
              (fuzool-kharchi ki), jab ke wo israaf na hoga. Furoo e Kafi, v3,
              p124
            </p>
          </div>
          <div className="btns" style={{ position: "relative", top: "-20px" }}>
            <button
              onClick={() => navigate("/knowmore")}
              type="button"
              className="btn btn-outline-info"
            >
              Know More
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={() => navigate("/donate")}
            >
              DONATE
            </button>
          </div>
        </div>
      </span>
      <span className="right">
        <img src={main} alt="Smiling Faces" />
      </span>
    </div>
  );
}
